const marketingNavigationFieldsSelector = ['sys.contentType', 'fields.links', 'fields.linksObject'].join(',')

export default marketingNavigationFieldsSelector
